import { render, staticRenderFns } from "./v-author-field.vue?vue&type=template&id=848c166c&scoped=true&"
import script from "./v-author-field.vue?vue&type=script&lang=js&"
export * from "./v-author-field.vue?vue&type=script&lang=js&"
import style0 from "./v-author-field.vue?vue&type=style&index=0&id=848c166c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c166c",
  null
  
)

export default component.exports